<template>
<v-container grid-list-xl>
              <v-layout >
                <v-flex>
                  <v-card dark color="primary">
                    <v-card-text>
                      <template>
                        <v-form>
    <v-text-field
      label="Title"
      required
      id = "title"
      v-model="title"
    ></v-text-field>
    <v-text-field
      label="Description"
      required
      id="desc"
      v-model="description"
    ></v-text-field>
  </v-form>
<v-switch label= "Turn on Dates" v-model="switch1"></v-switch>
  <v-layout row wrap v-show="switch1">
    <v-flex xs12 sm6 md4>
        <p style="font-size:120%"> Start Date </p>
        <v-date-picker v-model="date1"></v-date-picker>
    </v-flex>
    <v-spacer></v-spacer>
    <v-flex xs12 sm6 md4 v-show ="switch1">
        <p style="font-size:120%"> End Date </p>
        <v-date-picker v-model="date2"  :allowed-dates="selectableDays"></v-date-picker>
    </v-flex>
    <v-spacer></v-spacer>
  </v-layout>
  
<v-switch label= "Add Team Members" v-model="switch3"></v-switch>
<div v-show="switch3">
<v-flex xs12>
            <v-autocomplete
              :disabled="isUpdating"
              :items="filteredUsers"
              v-model="selected"
              box
              chips
              color="blue-grey lighten-2"
              label="Select Team Members"
              item-text="name"
              item-value="id"
              cache-items
              multiple
            >
              <template
                slot="selection"
                slot-scope="data"
                pa-5
              >
               <v-chip
                  :selected="data.selected"
                  close
                  class="chip--select-multi"
                  @input="data.parent.selectItem(data.item.id)"
                >
                  <v-avatar>
                    <img :src="data.item.photoURL">
                  </v-avatar>
                  {{ data.item.name }}
                </v-chip>
              </template>
              <template
                slot="item"
                slot-scope="data"
              >
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                  <v-list-tile-avatar>
                    <img :src="data.item.photoURL">
                  </v-list-tile-avatar>
                  <v-list-tile-content >
                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
</v-flex>
</div>
</template>
                    </v-card-text>
          <v-btn flat @click="submit">Submit</v-btn>
          <v-btn flat @click ="draft">Save as Draft</v-btn>
          <v-btn flat @click="Cancel">Cancel</v-btn>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
            </template>

            <script>
// create project to send to firebase
import firebase from '../../Firebase/FirebaseInit'
export default {
  data () {
    return {
      switch1: false,
      switch3: false,
      title: '',
      description: '',
      isUpdating: false,
      date1: new Date().trim,
      date2: new Date().trim,
      user: {},
      users: [],
      searchText: '',
      isContact: false,
      isPending: false,
      contacts: [],
      contactNames: [],
      next: false,
      dialog: false,
      selected: null
    }
  },
  watch: {
    selectedContact () {
      console.log('hola')
    },
    items () {
      console.log('hi')
    },
    selected () {
    }
  },
  computed: {
    filteredUsers () {
      this.something()
      return this.users.filter((user) => {
        return user.name.toLowerCase().match(this.searchText.toLowerCase())
      })
    }
  },
  components: {},
  methods: {
    Cancel () {
      this.reset()
      this.$emit('cancel')
    },
    reset () {
      this.switch1 = false
      this.switch3 = false
      this.isUpdating = false
      this.date1 = new Date().trim
      this.date2 = new Date().trim
      this.user = {}
      this.users = []
      this.searchText = ''
      this.isContact = false
      this.isPending = false
      this.contacts = []
      this.contactNames = []
      this.next = false
      this.dialog = false
      this.selected = null
      this.title = ''
      this.description = ''
    },
    draft () {
      console.log('at least one')
    },
    submit () {
      if (document.getElementById('title').value === '' || document.getElementById('desc').value === '' || (this.switch1 === true && (this.date1 === null || this.date2 === null))) {
        console.log('ISSUE')
        return
      }
      let members = (this.selected == null) ? [] : this.selected
      const project = {
        'title': document.getElementById('title').value,
        'description': document.getElementById('desc').value,
        'dates': true,
        'endDate': (this.switch1) ? this.date2 : 0,
        'startDate': (this.switch1) ? this.date1 : 0,
        'members': members,
        'creator': this.$store.getters.user,
        'files': []
      }
      this.$store.dispatch('CreateProject', project)
      for (var i = 0; i < members.length; i++) {
        let timestamp = new Date().getTime()
        let user = this.filteredUsers.filter((user) => user.id === members[i])
        if (user[0] != null) {
          const notification = {
            message: this.$store.getters.user.name + ' has added you to a project: ' + project.title,
            senderID: this.$store.getters.user.id,
            senderName: this.$store.getters.user.name,
            receiverID: user[0].id,
            receiverName: user[0].name,
            read: false,
            accepted: null,
            type: 'ProjectAdd',
            timestamp
          }
          this.$store.dispatch('sendNotification', notification)
        }
      }
      this.reset()
      this.$emit('new', project)
    },
    selectableDays (date) {
      if (date >= this.date1) {
        return -1
      }
    },
    something () {
      for (var i = 0; i < this.users.length; i++) {
        if (this.contactNames.includes(this.users[i].id)) {
          this.users[i].group = 'CONNECTED'
        }
      }
    }
  },
  created () {
    firebase.firestore().collection('users').doc(this.$store.getters.user.id).get().then((doc) => {
      let user = {
        'id': doc.id,
        'name': doc.data().name
      }
      this.user = user
    })
    .then(() => {
      firebase.firestore()
      .collection('users')
      .doc(this.user.id)
      .collection('contacts')
      .where('accepted', '==', true)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.contacts.push(doc.data())
          this.contactNames.push(doc.data().contactID)
        })
      })
      .catch((error) => {
        console.log('Error getting documents: ', error)
      })
    })
    firebase.firestore().collection('users').get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        let user = {
          'id': doc.id,
          'name': doc.data().name,
          'email': doc.data().email,
          'bio': doc.data().bio,
          'photoURL': doc.data().photoURL,
          'contacts': doc.data().contacts,
          'group': 'not connected'
        }
        if ((user.name != null) && (user.id !== this.user.id)) {
          this.users.push(user)
        }
      })
    })
  }
}
 </script>
 


// WEBPACK FOOTER //
// Projectdiag.vue?51a25147